const INITIAL_STATE = {
    customer: null,
    error: null,
    loaded: false,
    loading: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {

        case "CLEAR_CUSTOMER":
            return INITIAL_STATE;
        case "FETCH_CUSTOMER":
            return { ...state, customer: null, loading: true, loaded: false, error: null };
        case "FETCH_CUSTOMER_SUCCESS":
            return { ...state, customer: action.payload, error:null, loading: false, loaded: true };
        case "FETCH_CUSTOMER_FAILURE":
            error = action.payload || {message: action.payload.message};
            return { ...state, customer: null, error: error, loading: false, loaded: false };
        case "NEW_CUSTOMER": 
            return { ...state, customer: {
                adress1 : "",
                adress2 : "",
                branches : [],
                countryCode : "",
                countryName : null,
                deleted : false,
                locations : [],
                organizations: [],
                name : "",
                sync_errorText : null,
                sync_state : null 
            }, error: null, loadin: false, loaded: true
        };
        case "PERSIST_CUSTOMER":
            return { ...state, customer: action.payload};
        case "PERSIST_CUSTOMER_SUCCESS":
            return { ...state, customer: null, loading: false };
        case "PERSIST_CUSTOMER_FAILURE":
            error = action.payload || {message: action.payload.message};
            return { ...state, customer: action.payload, loading: false, loaded: false };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/customer.js